import React, { useRef, useState } from "react";

export function BeforeAfterSlider({ before, after, alt = "Treatment result", className = "" }) {
  const [pos, setPos] = useState(50);
  const ref = useRef(null);
  const dragging = useRef(false);

  const setFromClientX = (clientX) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const p = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.max(0, Math.min(100, p)));
  };

  const onDown = (e) => { dragging.current = true; setFromClientX(e.touches ? e.touches[0].clientX : e.clientX); };
  const onMove = (e) => { if (dragging.current) setFromClientX(e.touches ? e.touches[0].clientX : e.clientX); };
  const onUp = () => { dragging.current = false; };

  return (
    <div
      ref={ref}
      className={`relative overflow-hidden select-none ${className}`}
      onMouseDown={onDown}
      onMouseMove={onMove}
      onMouseUp={onUp}
      onMouseLeave={onUp}
      onTouchStart={onDown}
      onTouchMove={onMove}
      onTouchEnd={onUp}
      data-testid="before-after-slider"
    >
      {/* After (base layer) */}
      <img src={after} alt={`${alt} — after`} className="absolute inset-0 w-full h-full object-cover pointer-events-none" draggable={false} />
      <span className="absolute bottom-2 right-2 z-10 text-[10px] uppercase tracking-[0.15em] bg-ink/80 text-white px-2 py-0.5 rounded-full pointer-events-none">After</span>

      {/* Before (clipped) */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" style={{ width: `${pos}%` }}>
        <img
          src={before}
          alt={`${alt} — before`}
          className="absolute inset-0 h-full object-cover max-w-none"
          style={{ width: ref.current ? `${ref.current.getBoundingClientRect().width}px` : "100%" }}
          draggable={false}
        />
        <span className="absolute bottom-2 left-2 text-[10px] uppercase tracking-[0.15em] bg-ink/80 text-white px-2 py-0.5 rounded-full">Before</span>
      </div>

      {/* Divider + handle */}
      <div className="absolute top-0 bottom-0 z-20 pointer-events-none" style={{ left: `${pos}%`, transform: "translateX(-50%)" }}>
        <div className="w-0.5 h-full bg-white shadow-[0_0_6px_rgba(0,0,0,0.4)]" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-9 w-9 rounded-full bg-white shadow-lg flex items-center justify-center">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-ink">
            <path d="M8 7l-5 5 5 5M16 7l5 5-5 5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
      </div>

      {/* Accessible range control */}
      <input
        type="range"
        min="0"
        max="100"
        value={pos}
        onChange={(e) => setPos(Number(e.target.value))}
        aria-label="Drag to compare before and after"
        data-testid="before-after-range"
        className="absolute inset-0 z-30 w-full h-full opacity-0 cursor-ew-resize"
      />
    </div>
  );
}
